module.exports = __webpack_public_path__ + "static/media/MZW_02.a56cee32.jpg";